const PREFIX = "aberturavaga:";

// O hash da vaga é sempre o primeiro segmento da URL (/:hash/passo),
// então cada convite guarda suas respostas sob uma chave própria.
const getKey = () => {
  const [, hash] = window.location.pathname.split("/");
  return hash ? `${PREFIX}${hash}` : null;
};

export const loadState = () => {
  const key = getKey();
  if (!key) return undefined;

  try {
    const salvo = window.localStorage.getItem(key);
    if (!salvo) return undefined;

    const { respostas, idiomas } = JSON.parse(salvo);
    return {
      respostas: Array.isArray(respostas) ? respostas : [],
      idiomas: Array.isArray(idiomas) ? idiomas : []
    };
  } catch (e) {
    // localStorage indisponível (modo privado) ou conteúdo corrompido:
    // começa do zero em vez de derrubar a aplicação.
    return undefined;
  }
};

export const saveState = ({ respostas, idiomas }) => {
  const key = getKey();
  if (!key) return;

  try {
    window.localStorage.setItem(key, JSON.stringify({ respostas, idiomas }));
  } catch (e) {
    // cota estourada ou modo privado: segue sem persistir.
  }
};
